import React from "react"
import { Spacer } from "@bw/bits"
import { motion } from "framer-motion"
import { Link } from "gatsby"
import styled, { css } from "styled-components"
import { breakpoints } from "../../../theme"

const activeStyle = {
  fontWeight: 700,
}

const StyledTextItem = styled.div`
  font-weight: 500;
  text-decoration: none;
  color: var(--text-color);
  padding: 1.2em 0;
  font-size: 16px;
  line-height: 19px;
  cursor: default;

  &:not(:last-child) {
    border-bottom: 1px solid var(--layer-border-color, lightgray);
  }
`

const MobileLink = styled(Link)`
  font-weight: 500;
  text-decoration: none;
  color: currentColor;
  line-height: 19px;
  transition: opacity 0.25s ease-in-out;
  display: block;
  padding: 1.2em 0;
  border: 0;

  &:hover {
    opacity: 0.5;
  }

  &:not(:last-child) {
    border-bottom: 1px solid var(--layer-border-color, lightgray);
  }
`

const SubLevel = styled.div`
  padding-left: 20px;

  > * {
    font-weight: 400;
    font-size: 0.85em;
    border-bottom: 1px solid var(--layer-border-color, lightgray);
  }
`

const Shortcuts = styled.div`
  margin-bottom: 30px;
  font-size: 18px;

  @media (min-width: ${breakpoints.medium}px) {
    display: none;
  }
`

const MainLinks = styled.div`
  font-size: 20px;

  @media (min-width: ${breakpoints.medium}px) {
    font-size: 25px;
  }
`

const MobileMenu = ({ shortcuts, menu }) => {
  return (
    <>
      {shortcuts && (
        <Shortcuts>
          {shortcuts.map((item, i) => (
            <React.Fragment key={i}>
              {item.to ? (
                <MobileLink to={item.to} activeStyle={activeStyle}>
                  {item.label}
                </MobileLink>
              ) : (
                <StyledTextItem to={item.to}>{item.label}</StyledTextItem>
              )}
              {item.nested.length > 0 && (
                <SubLevel>
                  {item.nested.map(subItem => (
                    <MobileLink
                      key={subItem.page.to}
                      to={subItem.page.to}
                      activeStyle={activeStyle}
                    >
                      {subItem.page.label}
                    </MobileLink>
                  ))}
                </SubLevel>
              )}
            </React.Fragment>
          ))}
        </Shortcuts>
      )}
      {menu && (
        <MainLinks>
          {menu.map((item, i) => (
            <React.Fragment key={i}>
              {item.to ? (
                <MobileLink to={item.to} activeStyle={activeStyle}>
                  {item.label}
                </MobileLink>
              ) : (
                <StyledTextItem to={item.to}>{item.label}</StyledTextItem>
              )}
              {item.nested.length > 0 && (
                <SubLevel>
                  {item.nested.map(subItem => (
                    <MobileLink
                      key={subItem.page.to}
                      to={subItem.page.to}
                      activeStyle={activeStyle}
                    >
                      {subItem.page.label}
                    </MobileLink>
                  ))}
                </SubLevel>
              )}
            </React.Fragment>
          ))}
        </MainLinks>
      )}
    </>
  )
}

export default MobileMenu
